__turbopack_context__.v({
  "carousel": "oDuNgW_carousel",
  "events": "oDuNgW_events",
  "gradient": "oDuNgW_gradient",
  "shimmer": "oDuNgW_shimmer",
  "text-bar-sweep": "oDuNgW_text-bar-sweep",
});
